import { render, staticRenderFns } from "./PhvaWheel.vue?vue&type=template&id=f2a7f0a8&"
import script from "./PhvaWheel.vue?vue&type=script&lang=js&"
export * from "./PhvaWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports